import { IOfferHandler } from '../../types';
import { Offer } from '../../../../services/exports/Interfaces';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';

const useAmountOffByMinSpendValue: IOfferHandler = () => {
  const isUnlocked = (offer: Offer, items: CompleteBasketItem[]) =>
    items.reduce((acc, item) => acc + item.actual_price, 0) >= offer.details.min_spend_value;
  const getProfit = (offer: Offer, _: CompleteBasketItem[]) => offer.details.amount;

  return (offer, items) => ({
    profit: getProfit(offer, items),
    isEligible: isUnlocked(offer, items),
    isUnlocked: isUnlocked(offer, items),
  });
};

export default useAmountOffByMinSpendValue;
